<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="数值类型">
<!--                  <el-input  v-model="queryForm.valueType"></el-input>-->
                  <el-select
                      v-model="queryForm.valueType"
                      placeholder="请选择数值类型"
                      clearable
                      size="small"
                      style="width: 200px"
                  >
                      <el-option v-for="item in globalvalueTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="全局数值">
                  <el-input  style="width: 200px" v-model="queryForm.globalValue"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getReportGlobalvalueStoreList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addReportGlobalvalueStore"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editReportGlobalvalueStore(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteReportGlobalvalueStore(null)"
        >删除</el-button>
          <el-button
          type="primary"
          plain
          size="small"
          @click="showDateRecord"
        >每日数据</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入"xls"或"xlsx"格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshReportGlobalvalueStoreList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="reportGlobalvalueStoreList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="valueName"
        label="数值名称"
        min-width="180"
      >
          <template slot-scope='scop'>
              <div>{{computeGlobalvalueType(scop.row.valueType)}}</div>
          </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="valueType"-->
<!--        label="数值类型"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="globalValue"
        label="全局数值"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="todayValue"
        label="今日数值"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkReportGlobalvalueStore(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
              <div @click='showGlobalvalueRecord(scop.row.valueType)'>
                  <Icon size='16'>
                      <Eye24Regular />
                  </Icon>
                  <span class='operation-label'>查看记录</span>
              </div>
            <div @click="editReportGlobalvalueStore(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteReportGlobalvalueStore(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[50, 100, 200, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="reportGlobalvalueStoreStates[reportGlobalvalueStoreState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="reportGlobalvalueStore"
          ref="reportGlobalvalueStoreForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="数值名称"-->
<!--            prop="valueName"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="reportGlobalvalueStore.valueName"-->
<!--              :disabled="reportGlobalvalueStoreState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="数值名称"
            prop="valueType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="reportGlobalvalueStore.valueType"-->
<!--              :disabled="reportGlobalvalueStoreState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  v-model="reportGlobalvalueStore.valueType"
                  :disabled="reportGlobalvalueStoreState == 'check'"
                  placeholder="请选择数据名称"
                  clearable
                  size="small"
                  style="width: 200px"
              >
                  <el-option v-for="item in globalvalueTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="全局数值"
            prop="globalValue"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="reportGlobalvalueStore.globalValue"
              :disabled="reportGlobalvalueStoreState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="今日数值"
            prop="todayValue"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="reportGlobalvalueStore.todayValue"
              :disabled="reportGlobalvalueStoreState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="reportGlobalvalueStoreState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <el-drawer
          title="数据纪录"
          :visible.sync="recordStatus"
          direction="rtl"
          size="70%"
          :before-close="closeGlobalvalueRecord">
          <ReportGlobalvalueRecordStore ref='reportGlobalvalueRecordStore'></ReportGlobalvalueRecordStore>
      </el-drawer>

      <el-drawer
          title="每日数据"
          :visible.sync="dateStatus"
          direction="rtl"
          size="70%"
          :before-close="closeDateRecord">
          <ReportGlobalvalueDailyStore ref='reportDateRecordStore'></ReportGlobalvalueDailyStore>
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ReportGlobalvalueRecordStore from '@/components/report/ReportGlobalvalueRecordStore.vue';
import ReportGlobalvalueDailyStore from '@/components/report/ReportGlobalvalueDailyStore.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ReportGlobalvalueRecordStore,
        ReportGlobalvalueDailyStore
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetReportGlobalvalueStoreList();
                    this.getReportGlobalvalueStoreList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetReportGlobalvalueStoreList();
                    this.getReportGlobalvalueStoreList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     valueName: '', //数值名称
                     valueType: '', //数值类型
                     globalValue: '', //全局数值
                     todayValue: '', //今日数值，0点清空
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 50,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                reportGlobalvalueStoreState: 'add',
                reportGlobalvalueStoreStates: {
                    add: '新建门店全局数据',
                    check: '查看门店全局数据',
                    edit: '修改门店全局数据'
                },

                multipleSelection: [],
                reportGlobalvalueStoreList: [],
                reportGlobalvalueStore: {
                    id: '', //ID
                    valueName: '', //数值名称
                    valueType: '', //数值类型
                    globalValue: '', //全局数值
                    todayValue: '', //今日数值
                },
                btnLoading: false,
                recordStatus: false,
                globalvalueTypeEnumList: [],
                dateStatus: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    valueName: [{ required: true, message: '数值名称不能为空', trigger: 'blur' }],
                    valueType: [{ required: true, message: '数值类型不能为空', trigger: 'blur' }],
                    globalValue: [{ required: true, message: '全局数值不能为空', trigger: 'blur' }],
                    todayValue: [{ required: true, message: '今日数值', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getReportGlobalvalueStoreList();
            this.getGlobalvalueTypeEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            showGlobalvalueRecord(id){
                this.recordStatus = true
                this.$nextTick(()=>{
                    this.$refs.reportGlobalvalueRecordStore.init(id);
                })
            },
            closeGlobalvalueRecord(){
                this.recordStatus = false
            },
            showDateRecord(){
                this.dateStatus = true
                this.$nextTick(()=>{
                    this.$refs.reportDateRecordStore.init();
                })
            },
            closeDateRecord(){
                this.dateStatus = false
            },
            resetReportGlobalvalueStoreList() {
                this.pageSize = 50;
                this.currentPage = 1;
                this.reportGlobalvalueStoreList = [];
            },
            resetDialog() {
                this.reportGlobalvalueStoreState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      valueName: '', //数值名称
                      valueType: '', //数值类型
                      globalValue: '', //全局数值
                      todayValue: '', //今日数值
                };
                this.getReportGlobalvalueStoreList();
            },
            closeDialog() {
                this.showDialog = false
                this.reportGlobalvalueStore = {
                      id: '', //ID
                      valueName: '', //数值名称
                      valueType: '', //数值类型
                      globalValue: '', //全局数值
                      todayValue: '', //今日数值
                };
            },
            // 获取GlobalvalueTypeEnum
            getGlobalvalueTypeEnum(){
                get('/report/utils/getEnum',{
                    enumType: 'global_value_type_store_enum'
                }).then((res)=>{
                    if(res.success && res.code === 200){
                        this.globalvalueTypeEnumList = res.enumList
                    }
                })
            },

            // 计算computeGlobalvalue
            computeGlobalvalueType(type){
                for (let i = 0; i < this.globalvalueTypeEnumList.length; i++) {
                    if(this.globalvalueTypeEnumList[i].key === type){
                        return this.globalvalueTypeEnumList[i].value
                    }
                }
            },
            submitForm() {
                if (this.reportGlobalvalueStoreState == 'add') {
                    this.$refs.reportGlobalvalueStoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/globalvaluestore/add`,{ ...this.reportGlobalvalueStore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetReportGlobalvalueStoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.reportGlobalvalueStoreState == 'edit') {
                    this.$refs.reportGlobalvalueStoreForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/report/globalvaluestore/edit`,{ ...this.reportGlobalvalueStore }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetReportGlobalvalueStoreList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addReportGlobalvalueStore() {
                this.showDialog = true;
                this.reportGlobalvalueStoreState = 'add';
            },
            checkReportGlobalvalueStore(reportGlobalvalueStoreId) {
                console.log(reportGlobalvalueStoreId);
                this.currentReportGlobalvalueStoreId = reportGlobalvalueStoreId;

                this.getReportGlobalvalueStoreById();
                this.showDialog = true;
                this.reportGlobalvalueStoreState = 'check';
            },
            editReportGlobalvalueStore(reportGlobalvalueStoreId) {
                console.log('reportGlobalvalueStore', reportGlobalvalueStoreId);
                if (reportGlobalvalueStoreId) {
                    this.currentReportGlobalvalueStoreId = reportGlobalvalueStoreId;
                    this.getReportGlobalvalueStoreById();
                } else {
                    this.reportGlobalvalueStore = { ...this.reportGlobalvalueStore, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.reportGlobalvalueStoreState = 'edit';
            },
            deleteReportGlobalvalueStore(reportGlobalvalueStoreId) {
                let ids = '';
                if (reportGlobalvalueStoreId) {
                    ids = reportGlobalvalueStoreId;
                } else {
                    ids = this.multipleSelection.map((reportGlobalvalueStore) => reportGlobalvalueStore.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/report/globalvaluestore/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetReportGlobalvalueStoreList();
                                this.getReportGlobalvalueStoreList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshReportGlobalvalueStoreList() {
                this.resetReportGlobalvalueStoreList();
                this.getReportGlobalvalueStoreList();
            },
            getReportGlobalvalueStoreList(query = {}) {
                this.loading = true;
                get(`/report/globalvaluestore/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.reportGlobalvalueStoreList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getReportGlobalvalueStoreById() {
                get(`/report/globalvaluestore/get`,{ id: this.currentReportGlobalvalueStoreId }).then((res) =>{
                    if(res.success){
                      this.reportGlobalvalueStore = { ...this.reportGlobalvalueStore, ...res.reportGlobalvalueStore };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportReportGlobalvalueStoreList() {
                //this.btnLoading = true;
                exprotExcel(`/report/globalvaluestore/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/report/globalvaluestore/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/report/globalvaluestore/importData`,formData);
              this.refreshReportGlobalvalueStoreList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getReportGlobalvalueStoreList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getReportGlobalvalueStoreList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>